module.exports = __webpack_public_path__ + "img/169.50b6125b.jpg";